export const HTTP_OK = 200;
export const HTTP_UNPROCESSABLE_ENTITY = 422;
export const HTTP_EXPECTATION_FAILED = 417;
export const HTTP_NOT_FOUND = 404;
export const HTTP_INTERNAL_SERVER_ERROR = 500;
export const HTTP_NOT_ACCESS = 403;
